<template>
	<div>
		<keep-alive>
			<CardBackground
				class="img"
				:style="card_color"
			/>
		</keep-alive>
		<keep-alive>
			<component
				:is="fg_component"
				class="img"
				:style="card_color"
			/>
		</keep-alive>
	</div>
</template>

<style scoped>
.img {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
}

.colorable {
	fill: var(--card_color)
}
</style>

<script lang="ts">
import Vue from "vue";

import CardBackground from "@/assets/card_background.svg";
import CardNum0 from "@/assets/card_num_0.svg";
import CardNum1 from "@/assets/card_num_1.svg";
import CardNum2 from "@/assets/card_num_2.svg";
import CardNum3 from "@/assets/card_num_3.svg";
import CardNum4 from "@/assets/card_num_4.svg";
import CardNum5 from "@/assets/card_num_5.svg";
import CardNum6 from "@/assets/card_num_6.svg";
import CardNum7 from "@/assets/card_num_7.svg";
import CardNum8 from "@/assets/card_num_8.svg";
import CardNum9 from "@/assets/card_num_9.svg";
import CardReverse from "@/assets/card_reverse.svg";
import CardPlus2 from "@/assets/card_plus2.svg";
import CardSkip from "@/assets/card_skip.svg";
import CardWild from "@/assets/card_wild.svg";
import CardWildDrawFour from "@/assets/card_wild_draw_four.svg";

export default Vue.extend({
	components: {
		CardBackground,
		CardNum0,
		CardNum1,
		CardNum2,
		CardNum3,
		CardNum4,
		CardNum5,
		CardNum6,
		CardNum7,
		CardNum8,
		CardNum9,
		CardReverse,
		CardPlus2,
		CardSkip,
		CardWild,
		CardWildDrawFour
	},
	props: {
		type: Object
	},
	computed: {
		fg_component() {
			switch (this.type.type) {
			case "Number": return "CardNum" + this.type.num;
			case "Reverse": return "CardReverse";
			case "Plus2": return "CardPlus2";
			case "Skip": return "CardSkip";
			case "Wild": return "CardWild";
			case "WildDrawFour": return "CardWildDrawFour";
			}
			return "CardNum0";
		},
		card_color() {
			if (this.type.color_override != undefined) {
				switch (this.type.color_override) {
				case "Red":
					color = "#FF5555";
					break;
				case "Green":
					color = "#55AA55";
					break;
				case "Yellow":
					color = "#FFAA00";
					break;
				case "Blue":
					color = "#5555FF";
					break;
				}
				return {
					"--card_color": color
				};
			}
			var color = this.$store.state.dark ? "#FFFFFF" : "#000000";
			switch (this.type.type) {
			case "Number":
			case "Reverse":
			case "Plus2":
			case "Skip":
				switch (this.type.color) {
				case "Red":
					color = "#FF5555";
					break;
				case "Green":
					color = "#55AA55";
					break;
				case "Yellow":
					color = "#FFAA00";
					break;
				case "Blue":
					color = "#5555FF";
					break;
				}
			}
			return {
				"--card_color": color
			};
		}
	}
})
</script>
